module.exports = __webpack_public_path__ + "static/img/41.3450485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/41.png
// module id = yjoT
// module chunks = 1